__webpack_public_path__ = "http://dev.local:8080/assets/";

import "../scss/application.scss";
import {onLoading} from "./_modules/website";
import {loadPage} from "./_modules/home";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import imagesLoaded from "imagesloaded";

import './_modules/side-menu';

import Packery from "packery";
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse';

import {slideShow} from "./_modules/slideshow";
import {HandleAudio} from "./_modules/audio";
import {anchorsScroll} from "./_modules/anchorsScroll";
import {setLeftChrono} from "./_modules/chrono";


const Init = () => {
    UpdateTitle();
    updateActiveLink();
    slideShow();
    HandleAudio();
    anchorsScroll();
    setLeftChrono();
}

const UpdateTitle = () => {
    const curPageCont = document.querySelector('.current-page');
    const curTitle = document.body.dataset.title;
    if (curPageCont && curTitle) {
        curPageCont.innerHTML = curTitle;
    }
}

function updateActiveLink() {
    const links = document.querySelectorAll('.menu-link');
    const currentPath = window.location.pathname;

    // Remove 'active' class from all links
    links.forEach(link => link.classList.remove('active'));

    // Add 'active' class to the current link
    links.forEach(link => {
        if (link.getAttribute('href') === currentPath) {
            console.log(link.getAttribute('href'));
            link.classList.add('active');
        }
    });
}

function applySizing() {
    const grid = document.querySelector('.grid');
    if (window.packery && grid) {
        // Réinitialiser les tailles pour partir sur la base CSS
        grid?.querySelectorAll('.grid-item').forEach(item => {
            item.style.height = "";
            item.style.width = "";
        });

        // Trouver un "item normal" (pas un item wide)
        const normalItem = grid.querySelector('.grid-item:not([data-width="2"])');
        if (!normalItem) return;
        const normalHeight = normalItem.offsetHeight;

        const wideItems = grid.querySelectorAll('.grid-item[data-width="2"]');

        if (window.innerWidth > 1024) {
            wideItems.forEach(item => {
                item.style.height = (normalHeight * 1.5) + "px";
            });
        } else {
            wideItems.forEach(item => {
                item.style.height = "";
            });
        }

        // Recalcul Packery
        window.packery.layout();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    onLoading();
    loadPage();

    window.Alpine = Alpine
    Alpine.plugin(collapse);
    Alpine.start();




    window.dispatchEvent(new Event('resize'));

    window.swup = new Swup({
        linkToSelf: 'navigate',
        plugins: [
            new SwupBodyClassPlugin({
                prefix: 'page-',
                attributes: ['id', 'lang', 'dir', /^data-template/, /^data-title/,]
            }),
            new SwupPreloadPlugin(),
        ]
    });

    const grid = document.querySelector('.grid');
    if (grid) {
        window.packery = new Packery(grid, {
            itemSelector: '.grid-item',
            gutter: '.gutter-sizer',
            percentPosition: true,
        });


        imagesLoaded(grid, () => {
            console.log('images loaded');
            window.packery.layout();
            applySizing();
        });

        // Réappliquer au resize de la fenêtre
        window.addEventListener('resize', () => {
            applySizing();
        });
    }


    Init();

    window.swup.hooks.on('content:replace', (visit) => {
        Init();
    });

    window.swup.hooks.on('page:view', (visit) => {
        console.log('page:view');
        const CloseBtn = document.querySelector('.back-to-archives');
        let fromUrl = visit.from.url;

        CloseBtn?.setAttribute('href', fromUrl);

        const grid = document.querySelector('.grid');

        console.log(grid);

        if (grid) {
            if (window.packery) {
                window.packery.destroy();
            }
            window.packery = new Packery(grid, {
                itemSelector: '.grid-item',
                gutter: '.gutter-sizer', // Gutter size
                percentPosition: true, // Ensure percentage positioning
            });

            imagesLoaded(grid, () => {
                console.log('images loaded');
                window.packery.layout();
                applySizing();
            });

        }

        if (window.packery && grid !== null) {
            applySizing();
            console.log('images loaded');
        }

    });


});

